module.exports = __webpack_public_path__ + "images/mdj/members/mypage/top/top_bnr01-2d2cdbfedc10ab74e2d9d64f13984085.jpg";